const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'membership_auto_apply_discount',
    modelClass: require('./model'),
    viewClass: require('./view'),
    methods: {
        render(data) {
            this.render(data);
        },
        isAutoApplyDiscount() {
            return this.model.get('membershipDiscount').autoApplyDiscount;
        },
    },
});
